import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';

@Injectable()
export class SocketService {
	// SOCKET
	private socket: any = null;
	private userId: any = null;
	public permissions: any = null;
	constructor() {}

	// GESTIONE SOCKET
	getSocket(){
		return !!(this.socket);
	}

	getClientId() {
		return this.socket.id;
	}

	startSocket(serverUrl, serverPort) {
		console.log("SRV|KS - ALIVE!", Date.now() );
		this.socket = io(serverUrl+':'+serverPort, { transports: ['websocket']/*, upgrade: false*/});

		this.on('connect', () => {
			console.log("SRV|KS - CONNECT", this.socket.id);
			if(this.userId){
				this.sendUserId(this.userId);
			}
			if(this.permissions){
				this.setPermissions(this.permissions);
			}
		});
	}

	on(event, callback){
		this.socket.on(event, callback);
	}

	emit(event, params){
		this.socket.emit(event, params);
	}

	setIdComune(comuneId){
		this.socket.emit('setIdComune', this.socket.id, comuneId);
	}

	notificaSistema(notifica){
		this.socket.emit('notificaSistema', notifica);
	}

	setPermissions(permissions){
		//console.log("SRV|KS - SET PERMISSIONS", permissions, this.socket.id);
		this.socket.emit('setPermissions', this.socket.id, permissions);
	}

	addActivity(userId, comuneId, attivita, cosa, esito) {
		console.log("SRV|KS - ADD ACTIVITY", userId, comuneId, attivita, cosa, esito);
		this.socket.emit('addActivity', userId, comuneId, attivita, cosa, esito);
	}

	sendUserId(userId){
		console.log("SRV|KS - SEND USER ID", userId);
		this.userId = userId;
		if(this.socket.id && this.userId){
			console.log("SRV|KS - ID YES");
			this.socket.emit('setUserId', this.socket.id, this.userId);
		}else{
			console.log("SRV|KS - ID NO");
		}
	}
}
